var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.item,style:({ minHeight: _vm.minHeightComputed }),attrs:{"data-qa":"list-item"},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('div',{class:_vm.$style.icon},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{class:_vm.classes},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }